module.exports = __webpack_public_path__ + "static/media/fruit-02.6b70a358.png";